import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogLadle } from "../../../models/CatalogLadle";
type Props = {
  setLadle: (ladle: CatalogLadle) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewLadle: () => void;
};
export const useLadlesOptionsFunctions = ({
  setLadle,
  setShowModal,
  handleNewLadle,
}: Props) => {
  const getMenuOptions = (data: CatalogLadle) => {
    let options: MenuOptionType[] = [
      {
        name: "New Ladle",
        key: "new_ladle",
        onClick: () => {
          handleNewLadle();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Ladle",
          key: "edit_ladle",
          onClick: () => {
            setLadle(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Ladle",
          key: "delete_ladle",
          onClick: () => {
            setLadle(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
